import Debug from 'debug';
const debug = Debug('ot-slate:transform');

const transforms = {};

const transformKey = (type1, type2) => `${type1}-${type2}`;

const defineTransform = (type1, type2, transform) => {
  if (transforms[transformKey(type1, type2)]) {
    console.warn(`Already defined a transform for ${type1}, ${type2}`);
  }
  transforms[transformKey(type1, type2)] = transform;
};

const transform = (op1, op2, side) => {
  const transformFunction = transforms[transformKey(op1.type, op2.type)];
  if (transformFunction) {
    if (debug.enabled) {
      debug(`transforming (${side}) ${JSON.stringify(op1)}`);
      debug(`  against ${JSON.stringify(op2)}`);
    }

    const tOp = transformFunction(op1, op2, side);

    if (debug.enabled) {
      debug(`  became  ${JSON.stringify(tOp)}`);
    }

    return tOp;
  } else {
    console.warn(`Unhandled transform: "${op1.type}", "${op2.type}"`);
    return op1;
  }
};

export { defineTransform, transform };
